export type PageHeroId =
  | 'services'
  | 'insights'
  | 'about'
  | 'aboutInAction'
  | 'aboutMilestones'
  | 'testimonials'
  | 'contact';

export type PageHeroContent = {
  eyebrow: string;
  title: string;
  description: string;
  backgroundColor: string;
  backgroundImageUrl: string;
  overlayOpacity: number;
};

export type PageHeroMap = Record<PageHeroId, PageHeroContent>;

export const PAGE_HERO_META: Record<
  PageHeroId,
  {
    label: string;
    path: string;
    group: string;
  }
> = {
  services: {
    label: 'Services',
    path: '/services',
    group: 'Content Pages',
  },
  insights: {
    label: 'Insights',
    path: '/insights',
    group: 'Content Pages',
  },
  about: {
    label: 'About Us',
    path: '/about',
    group: 'About Pages',
  },
  aboutInAction: {
    label: 'In Action',
    path: '/about/in-action',
    group: 'About Pages',
  },
  aboutMilestones: {
    label: 'Milestones',
    path: '/about/milestones',
    group: 'About Pages',
  },
  testimonials: {
    label: 'Testimonials',
    path: '/testimonials',
    group: 'About Pages',
  },
  contact: {
    label: 'Contact',
    path: '/contact',
    group: 'Content Pages',
  },
};

export const PAGE_HERO_IDS = Object.keys(PAGE_HERO_META) as PageHeroId[];

export const mockPageHeroes: PageHeroMap = {
  services: {
    eyebrow: 'What We Offer',
    title: 'Our Consulting Services',
    description:
      'Three core pillars of expertise — Management, Policy and Engineering — each delivered with rigour, independence and a commitment to measurable results.',
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
  insights: {
    eyebrow: 'Knowledge & Perspectives',
    title: 'Insights',
    description:
      "Analysis, summaries and perspectives from Zobu Consulting's work in management, policy and engineering.",
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
  about: {
    eyebrow: 'Our Story',
    title: 'About Us',
    description:
      'Two decades of expertise, integrity and strategic excellence — serving clients across Turkey and beyond since 2004.',
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
  aboutInAction: {
    eyebrow: 'Behind the Work',
    title: 'In Action',
    description:
      'From boardrooms to field visits — a glimpse into how we work with clients across Turkey and beyond.',
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
  aboutMilestones: {
    eyebrow: '20 Years of Impact',
    title: 'Company Milestones',
    description:
      'From our founding in 2004 to today — key moments that shaped who we are. Click any milestone to read more.',
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
  testimonials: {
    eyebrow: 'Client Voices',
    title: 'Testimonials',
    description:
      'Words from the institutions and organisations that have trusted Zobu Consulting to deliver strategic impact.',
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
  contact: {
    eyebrow: 'Get In Touch',
    title: 'Contact Us',
    description:
      'Ready to discuss your challenge? We offer a free initial consultation.',
    backgroundColor: '#1c2937',
    backgroundImageUrl: '',
    overlayOpacity: 74,
  },
};
